import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function fieldRendersMainJSXForImports(field: SchemaField): boolean {
  if (field.hidden) return false
  if ((field.type === 'group' || field.type === 'section') && field.fields) {
    return field.fields.some(fieldRendersMainJSXForImports)
  }
  if (field.type === 'tabs') return Boolean(field.tabs?.length)
  return true
}
